import React from 'react';
import { Container, Accordion } from 'react-bootstrap';
import { useLanguage } from '../../context/LanguageContext';
import './Faq.css';

const Faq = () => {
  const { lang } = useLanguage();

  const content = {
    en: {
      title: "Frequently Asked Questions",
      subtitle: "Everything you need to know about Level 9 Coaching and our mission in Japan.",
      q1: "What is Level 9 Coaching?",
      a1: "Level 9 Coaching is an educational resource providing elite cybersecurity training and advice specifically tailored for the local Japanese market and culture. We help individuals and organizations navigate the digital landscape safely.",
      q2: "Why is cybersecurity education critical in Japan right now?",
      a2: "Japan is an innovation leader, but its culture often relies on traditional trust. Our goal is to educate the community on how to adopt a 'verify' mindset without losing that cultural essence, bridging the gap in modern digital protection.",
      q3: "Is the training available in Japanese?",
      a3: "Yes. Our mission is to speak the local language and understand the local culture, ensuring that cyber-safety concepts are practical and easy to absorb for everyone across different prefectures.",
      q4: "What is the 'Verify' philosophy mentioned by the founders?",
      a4: "It involves moving from 'trusting by default' to a 'verify everything' mindset (Zero Trust). This is the global standard of modern cybersecurity, and we tailor this concept to fit the Japanese business and social context.",
      q5: "Are the instructors certified?",
      a5: "Absolutely. While Level 9 Coaching focuses on local information and community support, our instructors hold globally recognized, advanced cybersecurity certifications such as C|CISO and E|CSA. They bring this high-level expertise to support you as you prepare for your professional journey."
    },
    jp: {
      title: "よくある質問",
      subtitle: "Level 9 Coachingと、日本における私たちのミッションについて知っておきたいすべての情報。",
      q1: "Level 9 Coachingとは何ですか？",
      a1: "Level 9 Coachingは、日本の市場や文化に合わせて設計された高度なサイバーセキュリティトレーニングとアドバイスを提供する教育プラットフォームです。個人や企業が安全にデジタル環境を活用できるようサポートしています。",
      q2: "なぜ今、日本ではサイバーセキュリティ教育が重要なのですか？",
      a2: "日本はイノベーションをリードする国である一方、従来の「信頼」に基づく文化も根強く残っています。私たちはその文化を大切にしながら、「必ず確認する（verify）」という考え方を広め、現代のデジタルセキュリティとのギャップを埋めることを目指しています。",
      q3: "トレーニングは日本語で受講できますか？",
      a3: "はい。私たちは現地の言語で伝え、文化を理解することを大切にしています。そのため、日本各地の方々にとって、サイバーセキュリティの考え方が実践的で分かりやすく身につくよう工夫しています。",
      q4: "創設者が提唱している「Verify（確認）」という考え方とは何ですか？",
      a4: "それは、「まず信頼する」という考え方から、「すべてを確認する（Verify）」というゼロトラストの考え方へと移行することです。これは現代のサイバーセキュリティの世界標準であり、私たちは日本のビジネスや社会に合う形でこの概念を伝えています。",
      q5: "講師は認定資格を取得していますか？",
      a5: "もちろんです。Level 9 Coachingは地域に根ざした情報提供やコミュニティサポートに重点を置いていますが、講師陣はC|CISOやE|CSAといった国際的に認められた高度なサイバーセキュリティ資格を有しています。これらの専門性を活かし、皆さまのキャリア形成をしっかりサポートします。"
    }
  };

  const t = content[lang];

  return (
    <div className="faq-page">
      <section className="faq-hero py-5">
        <Container>
          <div className="text-center mb-5">
            <h2 className="gs-main-title">{t.title}</h2>
            <div className="small-red-line mx-auto"></div>
            <p className="gs-subtitle mx-auto mt-4">{t.subtitle}</p>
          </div>

          <Accordion className="custom-accordion mx-auto">
            <Accordion.Item eventKey="0">
              <Accordion.Header>{t.q1}</Accordion.Header>
              <Accordion.Body>{t.a1}</Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="1">
              <Accordion.Header>{t.q2}</Accordion.Header>
              <Accordion.Body>{t.a2}</Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="2">
              <Accordion.Header>{t.q3}</Accordion.Header>
              <Accordion.Body>{t.a3}</Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="3">
              <Accordion.Header>{t.q4}</Accordion.Header>
              <Accordion.Body>{t.a4}</Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="4">
              <Accordion.Header>{t.q5}</Accordion.Header>
              <Accordion.Body>
                {t.a5}
              </Accordion.Body>
            </Accordion.Item>

          </Accordion>
        </Container>
      </section>
    </div>
  );
};

export default Faq;